// import external dependencies
import 'jquery';

// Import everything from autoload
//;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import news from './routes/news';
import magazin from './routes/magazin';
import datesData from './routes/dates';
import questionsData from './routes/questions';
import consultantsData from './routes/consultants';
import contractorSearchData from './routes/contractor-search';
import contractorFormData from './routes/contractor-form';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // News page
  news,
  // Dates page
  datesData,
  // Questions & Answers page
  questionsData,
  // Consultants page
  consultantsData,
  // Contractors page
  contractorSearchData,
  // Contractors form
  contractorFormData,
  //Magazine
  magazin,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js